<template>

    <div class="panel panel-clinic">

        <div class="panel-heading" href="#customer_trash_panel" data-toggle="collapse">

            <div class="arrow-down"></div>

            <h2 class="panel-title">GDPR</h2>

        </div>

        <div id="customer_trash_panel" class="panel-collapse collapse">

            <div class="panel-body" style="padding-top:0;">

                <h2>Radera kund</h2>
                <p>Kunden raderas fem år efter att sista klippkortet utgått. Görs i huvudsak automatiskt.</p>
                <button class="btn btn-danger" @click="trash()">Radera kund</button>

            </div>

        </div>

    </div>

</template>

<script>
    export default {
        props: {
            customerId: {
                required: true
            }
        },
        data() {
            return {

            }
        },
        methods: {
            trash()
            {
                var self = this
                if(!confirm('All information om kunden tas bort från databasen, är du säker?')) {
                    return
                }
                if(!confirm('Bekräfta igen')) {
                    return
                }

                self.$http.delete('/customers/'+self.customerId).then((response) => {
                    console.log('trash customers response')
                    console.log(response.data)

                    bus.$emit('notify', 'Kunden har raderats från systemet.')
                    window.location.href = '/customers'

                }, (response) => {
                    console.log(JSON.stringify(response));
                });
            }
        }
    }
</script>
